import PlanejamentoAcaoFormCamposNovo from '../../../produto/spa/planejamento-acao/form/PlanejamentoAcaoFormCamposNovo';

export default PlanejamentoAcaoFormCamposNovo;
